module.exports = __webpack_public_path__ + "img/media-location.b0b66dd8.png";